/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addEmployeeLog } from '../fn/employee/add-employee-log';
import { AddEmployeeLog$Params } from '../fn/employee/add-employee-log';
import { addEmployeeToVenues } from '../fn/employee/add-employee-to-venues';
import { AddEmployeeToVenues$Params } from '../fn/employee/add-employee-to-venues';
import { deleteEmployee } from '../fn/employee/delete-employee';
import { DeleteEmployee$Params } from '../fn/employee/delete-employee';
import { UsersDto as DigiworkMaitreDDtoUsersDto } from '../models/Digiwork/MaitreD/DTO/users-dto';
import { EmployeeDto as DigiworkMaitreDPosDtoEmployeeEmployeeDto } from '../models/Digiwork/MaitreD/Pos/DTO/Employee/employee-dto';
import { employeeRemoveFromVenue } from '../fn/employee/employee-remove-from-venue';
import { EmployeeRemoveFromVenue$Params } from '../fn/employee/employee-remove-from-venue';
import { getEmployeeDetails } from '../fn/employee/get-employee-details';
import { GetEmployeeDetails$Params } from '../fn/employee/get-employee-details';
import { getNewPin } from '../fn/employee/get-new-pin';
import { getNewPin_1 } from '../fn/employee/get-new-pin-1';
import { GetNewPin_1$Params } from '../fn/employee/get-new-pin-1';
import { GetNewPin$Params } from '../fn/employee/get-new-pin';
import { listAllEmployees } from '../fn/employee/list-all-employees';
import { ListAllEmployees$Params } from '../fn/employee/list-all-employees';
import { listAllEmployeesForVenue } from '../fn/employee/list-all-employees-for-venue';
import { listAllEmployeesForVenue_1 } from '../fn/employee/list-all-employees-for-venue-1';
import { ListAllEmployeesForVenue_1$Params } from '../fn/employee/list-all-employees-for-venue-1';
import { ListAllEmployeesForVenue$Params } from '../fn/employee/list-all-employees-for-venue';
import { listAllWaitersForVenue } from '../fn/employee/list-all-waiters-for-venue';
import { ListAllWaitersForVenue$Params } from '../fn/employee/list-all-waiters-for-venue';
import { listManagerEmployeesForVenue } from '../fn/employee/list-manager-employees-for-venue';
import { ListManagerEmployeesForVenue$Params } from '../fn/employee/list-manager-employees-for-venue';
import { registerManager } from '../fn/employee/register-manager';
import { RegisterManager$Params } from '../fn/employee/register-manager';
import { registerWaiter } from '../fn/employee/register-waiter';
import { RegisterWaiter$Params } from '../fn/employee/register-waiter';
import { remoteLogoutEmployee } from '../fn/employee/remote-logout-employee';
import { RemoteLogoutEmployee$Params } from '../fn/employee/remote-logout-employee';
import { removeEmployeeLog } from '../fn/employee/remove-employee-log';
import { RemoveEmployeeLog$Params } from '../fn/employee/remove-employee-log';
import { updateEmployee } from '../fn/employee/update-employee';
import { updateEmployee_1 } from '../fn/employee/update-employee-1';
import { UpdateEmployee_1$Params } from '../fn/employee/update-employee-1';
import { UpdateEmployee$Params } from '../fn/employee/update-employee';
import { updateEmployeeLog } from '../fn/employee/update-employee-log';
import { UpdateEmployeeLog$Params } from '../fn/employee/update-employee-log';

@Injectable({ providedIn: 'root' })
export class EmployeeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateEmployee()` */
  static readonly UpdateEmployeePath = '/api/mng/Employee/updateemployee';

  /**
   * Update existing employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEmployee()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateEmployee$Response(params?: UpdateEmployee$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEmployee(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEmployee$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateEmployee(params?: UpdateEmployee$Params, context?: HttpContext): Observable<void> {
    return this.updateEmployee$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addEmployeeLog()` */
  static readonly AddEmployeeLogPath = '/api/mng/Employee/addemployeelog';

  /**
   * Add time log for the employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addEmployeeLog()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addEmployeeLog$Response(params?: AddEmployeeLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addEmployeeLog(this.http, this.rootUrl, params, context);
  }

  /**
   * Add time log for the employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addEmployeeLog$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addEmployeeLog(params?: AddEmployeeLog$Params, context?: HttpContext): Observable<void> {
    return this.addEmployeeLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateEmployeeLog()` */
  static readonly UpdateEmployeeLogPath = '/api/mng/Employee/updateemployeelog';

  /**
   * Update time log for the employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEmployeeLog()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEmployeeLog$Response(params?: UpdateEmployeeLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEmployeeLog(this.http, this.rootUrl, params, context);
  }

  /**
   * Update time log for the employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEmployeeLog$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateEmployeeLog(params?: UpdateEmployeeLog$Params, context?: HttpContext): Observable<void> {
    return this.updateEmployeeLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeEmployeeLog()` */
  static readonly RemoveEmployeeLogPath = '/api/mng/Employee/removeemployeelog';

  /**
   * Remove time log for employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeEmployeeLog()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeEmployeeLog$Response(params?: RemoveEmployeeLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeEmployeeLog(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove time log for employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeEmployeeLog$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeEmployeeLog(params?: RemoveEmployeeLog$Params, context?: HttpContext): Observable<void> {
    return this.removeEmployeeLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `employeeRemoveFromVenue()` */
  static readonly EmployeeRemoveFromVenuePath = '/api/mng/Employee/employeeremovefromvenue';

  /**
   * Remove existing employee from a venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employeeRemoveFromVenue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  employeeRemoveFromVenue$Response(params?: EmployeeRemoveFromVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return employeeRemoveFromVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove existing employee from a venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employeeRemoveFromVenue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  employeeRemoveFromVenue(params?: EmployeeRemoveFromVenue$Params, context?: HttpContext): Observable<void> {
    return this.employeeRemoveFromVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllEmployeesForVenue()` */
  static readonly ListAllEmployeesForVenuePath = '/api/mng/Employee/listallemployeesforvenue';

  /**
   * List all employees for specific venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllEmployeesForVenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllEmployeesForVenue$Response(params?: ListAllEmployeesForVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>> {
    return listAllEmployeesForVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * List all employees for specific venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllEmployeesForVenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllEmployeesForVenue(params?: ListAllEmployeesForVenue$Params, context?: HttpContext): Observable<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>> {
    return this.listAllEmployeesForVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>): Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto> => r.body)
    );
  }

  /** Path part for operation `listAllWaitersForVenue()` */
  static readonly ListAllWaitersForVenuePath = '/api/mng/Employee/listallwaitersforvenue';

  /**
   * List all waiters for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllWaitersForVenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllWaitersForVenue$Response(params?: ListAllWaitersForVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listAllWaitersForVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * List all waiters for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllWaitersForVenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllWaitersForVenue(params?: ListAllWaitersForVenue$Params, context?: HttpContext): Observable<void> {
    return this.listAllWaitersForVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNewPin()` */
  static readonly GetNewPinPath = '/api/mng/Employee/getnewpin';

  /**
   * Get new pin for registration og new employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNewPin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewPin$Response(params?: GetNewPin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getNewPin(this.http, this.rootUrl, params, context);
  }

  /**
   * Get new pin for registration og new employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNewPin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewPin(params?: GetNewPin$Params, context?: HttpContext): Observable<void> {
    return this.getNewPin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `remoteLogoutEmployee()` */
  static readonly RemoteLogoutEmployeePath = '/api/mng/Employee/remotelogoutemployee';

  /**
   * Notify employee for remote logout.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `remoteLogoutEmployee()` instead.
   *
   * This method doesn't expect any request body.
   */
  remoteLogoutEmployee$Response(params?: RemoteLogoutEmployee$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return remoteLogoutEmployee(this.http, this.rootUrl, params, context);
  }

  /**
   * Notify employee for remote logout.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `remoteLogoutEmployee$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  remoteLogoutEmployee(params?: RemoteLogoutEmployee$Params, context?: HttpContext): Observable<void> {
    return this.remoteLogoutEmployee$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerManager()` */
  static readonly RegisterManagerPath = '/api/gmn/Employee/registermanager';

  /**
   * Register new user of type "POS Manager".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerManager()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registerManager$Response(params?: RegisterManager$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return registerManager(this.http, this.rootUrl, params, context);
  }

  /**
   * Register new user of type "POS Manager".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerManager$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registerManager(params?: RegisterManager$Params, context?: HttpContext): Observable<void> {
    return this.registerManager$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerWaiter()` */
  static readonly RegisterWaiterPath = '/api/gmn/Employee/registerwaiter';

  /**
   * Register new user of type "Waiter".
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerWaiter()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registerWaiter$Response(params?: RegisterWaiter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return registerWaiter(this.http, this.rootUrl, params, context);
  }

  /**
   * Register new user of type "Waiter".
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerWaiter$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registerWaiter(params?: RegisterWaiter$Params, context?: HttpContext): Observable<void> {
    return this.registerWaiter$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllEmployees()` */
  static readonly ListAllEmployeesPath = '/api/gmn/Employee/listallemployees';

  /**
   * List all employees for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllEmployees()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllEmployees$Response(params?: ListAllEmployees$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listAllEmployees(this.http, this.rootUrl, params, context);
  }

  /**
   * List all employees for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllEmployees$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllEmployees(params?: ListAllEmployees$Params, context?: HttpContext): Observable<void> {
    return this.listAllEmployees$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listManagerEmployeesForVenue()` */
  static readonly ListManagerEmployeesForVenuePath = '/api/gmn/Employee/listmanageremployeesforvenue';

  /**
   * List all employees for specific venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listManagerEmployeesForVenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  listManagerEmployeesForVenue$Response(params?: ListManagerEmployeesForVenue$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoUsersDto>> {
    return listManagerEmployeesForVenue(this.http, this.rootUrl, params, context);
  }

  /**
   * List all employees for specific venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listManagerEmployeesForVenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listManagerEmployeesForVenue(params?: ListManagerEmployeesForVenue$Params, context?: HttpContext): Observable<DigiworkMaitreDDtoUsersDto> {
    return this.listManagerEmployeesForVenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDDtoUsersDto>): DigiworkMaitreDDtoUsersDto => r.body)
    );
  }

  /** Path part for operation `getEmployeeDetails()` */
  static readonly GetEmployeeDetailsPath = '/api/gmn/Employee/getemployeedetails';

  /**
   * Get employee details for id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEmployeeDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEmployeeDetails$Response(params?: GetEmployeeDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getEmployeeDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * Get employee details for id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEmployeeDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEmployeeDetails(params?: GetEmployeeDetails$Params, context?: HttpContext): Observable<void> {
    return this.getEmployeeDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateEmployee_1()` */
  static readonly UpdateEmployee_1Path = '/api/gmn/Employee/updateemployee';

  /**
   * Update existing employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEmployee_1()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateEmployee_1$Response(params?: UpdateEmployee_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEmployee_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEmployee_1$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateEmployee_1(params?: UpdateEmployee_1$Params, context?: HttpContext): Observable<void> {
    return this.updateEmployee_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteEmployee()` */
  static readonly DeleteEmployeePath = '/api/gmn/Employee/deleteemployee';

  /**
   * Delete existing employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEmployee()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteEmployee$Response(params?: DeleteEmployee$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEmployee(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete existing employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEmployee$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteEmployee(params?: DeleteEmployee$Params, context?: HttpContext): Observable<void> {
    return this.deleteEmployee$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addEmployeeToVenues()` */
  static readonly AddEmployeeToVenuesPath = '/api/gmn/Employee/addemployeetovenues';

  /**
   * Add some employee to venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addEmployeeToVenues()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addEmployeeToVenues$Response(params?: AddEmployeeToVenues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addEmployeeToVenues(this.http, this.rootUrl, params, context);
  }

  /**
   * Add some employee to venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addEmployeeToVenues$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addEmployeeToVenues(params?: AddEmployeeToVenues$Params, context?: HttpContext): Observable<void> {
    return this.addEmployeeToVenues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllEmployeesForVenue_1()` */
  static readonly ListAllEmployeesForVenue_1Path = '/api/gmn/Employee/listallemployeesforvenue';

  /**
   * List all employees for specific venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllEmployeesForVenue_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllEmployeesForVenue_1$Response(params?: ListAllEmployeesForVenue_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>> {
    return listAllEmployeesForVenue_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List all employees for specific venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllEmployeesForVenue_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllEmployeesForVenue_1(params?: ListAllEmployeesForVenue_1$Params, context?: HttpContext): Observable<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>> {
    return this.listAllEmployeesForVenue_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto>>): Array<DigiworkMaitreDPosDtoEmployeeEmployeeDto> => r.body)
    );
  }

  /** Path part for operation `getNewPin_1()` */
  static readonly GetNewPin_1Path = '/api/gmn/Employee/getnewpin';

  /**
   * Get new pin for registration og new employee.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNewPin_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewPin_1$Response(params?: GetNewPin_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getNewPin_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get new pin for registration og new employee.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNewPin_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNewPin_1(params?: GetNewPin_1$Params, context?: HttpContext): Observable<void> {
    return this.getNewPin_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
